import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const CustomRadioButton = ({ options, value, onChange, component, form }) => {
	const [selectedValue, setValue] = useState(null);
	const [t, i18n] = useTranslation();
	const handleOptionChange = (options) => {
		if (options.isSubmitButton === true) {
			form.submit();
		} else {
			if (component.disabled !== true) {
				const selectedOption = { label: options.label, value: options.value };
				onChange(selectedOption); // Update the selected value
				setValue(selectedOption); // Update the local state value
				//console.log("select value :", optionValue);
			}
		}
	};
	useEffect(() => {
		if (value !== undefined && value !== null) {
			if (typeof value === "object" && value.label !== undefined && value.value !== undefined) {
				setValue(value);
				onChange(value);
			} else {
				const inputValue = options.find((opt) => String(opt.value) === String(value));
				if (inputValue) {
					setValue({ label: inputValue.label, value: inputValue.value });
					onChange({ label: inputValue.label, value: inputValue.value });
				}
			}
		} else if (options?.length > 0) {
			const defaultValue = { label: options[0].label, value: options[0].value };
			setValue(defaultValue);
			onChange(defaultValue);
		}
	}, [value, options]);

	return (
		<div className="custom-radio-group">
			{options.map((option, index) => (
				<div key={index} className="radio-option">
					<div className="image-container">
						{/* <img src={option.image[0]?.url} alt={option.label} onClick={() => handleOptionChange(option.value)} /> */}
						<img
							disabled={component.disabled === true}
							src={option.image[0]?.url}
							alt={option.label}
							onClick={() => handleOptionChange(option)}
							className={String(selectedValue?.value) === String(option.value) && option.isSubmitButton !== true ? "image-container selected" : "image-container"}
						/>
					</div>
					{!option.isHidden && (
						<div className="radio-container">
							<input
								disabled={component.disabled === true}
								type="radio"
								id={`radio_${index}`}
								value={option.value}
								checked={String(selectedValue?.value) === String(option.value)}
								onChange={() => handleOptionChange(option)}
							/>
						</div>
					)}
					<div className="label-container">
						<label style={{ fontFamily: "IBMPlexSansArabic-Regular" }} htmlFor={`radio_${index}`}>
							{t(option.label)}
						</label>
					</div>
				</div>
			))}
		</div>
	);
};

export default CustomRadioButton;
